import { render, staticRenderFns } from "./PlanMovil.vue?vue&type=template&id=9ae0b7b6&scoped=true"
import script from "./PlanMovil.vue?vue&type=script&lang=js"
export * from "./PlanMovil.vue?vue&type=script&lang=js"
import style0 from "./PlanMovil.vue?vue&type=style&index=0&id=9ae0b7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae0b7b6",
  null
  
)

export default component.exports